import { render, staticRenderFns } from "./EmptyMessage.vue?vue&type=template&id=206c8e6e&scoped=true&"
import script from "./EmptyMessage.vue?vue&type=script&lang=js&"
export * from "./EmptyMessage.vue?vue&type=script&lang=js&"
import style0 from "./EmptyMessage.vue?vue&type=style&index=0&id=206c8e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c8e6e",
  null
  
)

export default component.exports